import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export const authentication = {
  namespaced: true,
  state: {
    config: {
      ID_PORTAL: null,
      API_URL: null,
      AUTH_API_URL: null,
      AUTHORITY: null,
      CLIENT_ID: null,
      POST_LOGOUT_REDIRECT_URL: null,
      REDIRECT_URL: null
    },
    portalInfo: null,
    profile: null,
    token: null,
    acceptTerms: {
      isAcceptTerms: false,
      message: null
    }
  },
  getters,
  mutations,
  actions
};
